// extracted by mini-css-extract-plugin
export default {"cookiesBox":"CookieBox_cookiesBox__upYuN","text":"CookieBox_text__Zus93","link":"CookieBox_link__29-Se","textLink":"CookieBox_textLink__g-Ck7","button":"CookieBox_button__VeHIq"};